module.exports = __webpack_public_path__ + "static/media/32.bcad4c23.png";